import { render, staticRenderFns } from "./WikiLink.vue?vue&type=template&id=488ca4fe&scoped=true&"
import script from "./WikiLink.vue?vue&type=script&lang=js&"
export * from "./WikiLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ca4fe",
  null
  
)

export default component.exports